<template>
  <FormEdit
    :errors="errors"
    :fields="fields"
    model="hair-color"
    @submitted="update"
  >
    <div class="elr-row">
      <div class="elr-col-full">
        <InputText
          label="Hair Color"
          v-model="formData.name"
          fieldName="name"
          :errors="errors"
          errorMessage="the name field is required"
          :required=true
        />
      </div>
    </div>
    <div class="elr-row">
      <div class="elr-col-full">
        <InputSelect
          label="Color Family"
          v-model="formData.color_family"
          fieldName="color_families"
          :errors="errors"
          :errorMessage="(errors && errors.color_family) ? errors.color_family[0] : null"
          :required=true
          :values="colorFamilies"
        />
      </div>
    </div>
    <div class="elr-row">
      <div class="elr-col-full">
        <InputTextArea
          label="Description"
          v-model="formData.description"
          fieldName="description"
        />
      </div>
    </div>
  </FormEdit>
</template>

<script>
import { colorFamilies } from '../../data/config.json';
import FormEdit from '../FormEdit/FormEdit';
import InputText from '../InputText/InputText';
import InputSelect from '../InputSelect/InputSelect';
import InputTextArea from '../InputTextArea/InputTextArea';

export default {
  name: 'FormHairColorEdit',
  props: {
    id: {
      type: String,
      required: true
    },
    hairColor: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      colorFamilies,
      formData: {
        name: null,
        color_family: null,
        description: null
      },
      fields: [
        {
          name: 'name',
          label: 'Color Name',
          type: 'text',
          rules: 'required|isAlphaSpaces|isMinLength:2|isMaxLength:50',
        },
        {
          name: 'color_family',
          label: 'Color Family',
          type: 'text',
          rules: 'required|isAlphaSpaces|isMinLength:2|isMaxLength:50',
        },
        {
          name: 'description',
          label: 'Description',
          type: 'textarea'
        }
      ]
    };
  },
  components: {
    FormEdit,
    InputText,
    InputTextArea,
    InputSelect
  },
  mounted() {
    this.formData = Object.assign({}, {
      name: this.hairColor.name,
      color_family: this.hairColor.color_family,
      description: this.hairColor.description
    });
  },
  computed: {
    errors() {
      return this.$store.state.item.errors ? this.$store.state.item.errors[0] : {};
    }
  },
  methods: {
    update() {
      this.$store.dispatch('hairColor/UPDATE', this.formData);
    }
  },
  watch: {
    hairColor() {
      this.formData = Object.assign({}, {
        id: this.hairColor.id,
        name: this.hairColor.name,
        color_family: this.hairColor.color_family,
        description: this.hairColor.description
      });
    }
  }
};
</script>
